/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Birth_Date_HintInputs */

const en_signup_birth_date_hint = /** @type {(inputs: Signup_Birth_Date_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounts are for people aged 18 or over.`)
};

const pl_signup_birth_date_hint = /** @type {(inputs: Signup_Birth_Date_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konta są dla osób, które ukończyły 18 lat.`)
};

/**
* | output |
* | --- |
* | "Accounts are for people aged 18 or over." |
*
* @param {Signup_Birth_Date_HintInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const signup_birth_date_hint = /** @type {((inputs?: Signup_Birth_Date_HintInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Birth_Date_HintInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_signup_birth_date_hint(inputs)
	return en_signup_birth_date_hint(inputs)
});